import { Component } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, Validators } from '@angular/forms';


@Component({
  selector: 'app-activate-account',
  templateUrl: './activate-account.component.html',
  styleUrls: ['./activate-account.component.scss']
})
export class ActivateAccountComponent {

  id: string | undefined;
  key: string | undefined;

  message : string | undefined
  canLogin = false

  forgotForm =  this.formBuilder.group({
    key: ['', [Validators.required]],
  });


  constructor(
    private route: ActivatedRoute,
    private dataService : DataService,
    private formBuilder: UntypedFormBuilder,
    private router2: Router,
    ){
      this.route.queryParams.subscribe(params => {
        this.id = params['id'];
        this.key = params['key'];
      });
  }

  ngOnInit(){
    this.onSubmit()
  }
  

  login(){
    this.router2.navigate(["/login"]);
  }

 async onSubmit() {
    try {
      let data = {
        id : this.id,
        key : this.key
      }
      const res =  await this.dataService.postData('user/activate-account-link',data,'PUT',false)
      if(res.error){
        this.message = res.msg
      }
       else {
        this.message = res.msg
        this.canLogin = true
       }

    } catch (error) {
      console.log(error)
    }
  }


}
